import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "drop-down-list",
  "use": "drop-down-list-usage",
  "viewBox": "0 0 401.141 401.141",
  "content": "<symbol viewBox=\"0 0 401.141 401.141\" id=\"drop-down-list\"><path d=\"M101.847 160.827v64.423h299.294v-64.423H101.847zm280.588 45.717H120.553v-27.012h261.882v27.012zm-280.588 93.53h299.294V235.65H101.847v64.424zm18.706-45.718h261.882v27.012H120.553v-27.012zm-18.706 120.023h299.294v-64.423H101.847v64.423zm18.706-45.717h261.882v27.012H120.553v-27.012zm178.741-189.665h81.059V26.762H0v112.235H299.294zm0-93.53h62.353v74.824h-62.353V45.467zM18.706 120.291V45.467h261.883v74.824H18.706zm292.529-46.448h40.962l-20.484 26.04-20.478-26.04z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/drop-down-list.svg
// module id = IXhk
// module chunks = 1